var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 69,
    viewBox: "0 0 106 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05,
    filter: "url(#filter0_d_15_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7 30.7C54.7 36.5667 53.6 41.8 51.4 46.4C49.2667 50.9333 46.3 54.5 42.5 57.1C38.7 59.7 34.4 61 29.6 61C24.8 61 20.5 59.7 16.7 57.1C12.9667 54.5 10 50.9333 7.8 46.4C5.6 41.8 4.5 36.5667 4.5 30.7C4.5 24.8333 5.6 19.6333 7.8 15.1C10 10.5 12.9667 6.9 16.7 4.3C20.5 1.63333 24.8 0.3 29.6 0.3C34.4 0.3 38.7 1.63333 42.5 4.3C46.3 6.9 49.2667 10.5 51.4 15.1C53.6 19.6333 54.7 24.8333 54.7 30.7ZM47.8 30.7C47.8 25.9667 47.0333 21.8 45.5 18.2C43.9667 14.6 41.8333 11.8 39.1 9.8C36.3667 7.73333 33.2 6.69999 29.6 6.69999C26 6.69999 22.8333 7.73333 20.1 9.8C17.3667 11.8 15.2 14.6 13.6 18.2C12.0667 21.8 11.3 25.9667 11.3 30.7C11.3 35.4333 12.0667 39.6 13.6 43.2C15.2 46.8 17.3667 49.6 20.1 51.6C22.8333 53.6 26 54.6 29.6 54.6C33.2 54.6 36.3667 53.6 39.1 51.6C41.8333 49.5333 43.9667 46.7333 45.5 43.2C47.0333 39.6 47.8 35.4333 47.8 30.7ZM101.33 53.8V60H67.4305V53.8H81.6305V11C81.0971 11.8 80.1971 12.6667 78.9305 13.6C77.6638 14.5333 76.1971 15.4 74.5305 16.2C72.9305 17 71.3305 17.6667 69.7305 18.2C68.1305 18.7333 66.6638 19 65.3305 19V12.4C66.8638 12.4 68.5305 11.9667 70.3305 11.1C72.1305 10.2333 73.8638 9.23333 75.5305 8.09999C77.1971 6.96666 78.5971 5.9 79.7305 4.9C80.8638 3.9 81.4971 3.23333 81.6305 2.9H88.6305V53.8H101.33Z",
    fill: "#515151"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15_1118",
    x: 0.5,
    y: 0.300049,
    width: 104.831,
    height: 68.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15_1118"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15_1118",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.b81c9fcb811b7eb255ea566d787bd832.svg";
export { ForwardRef as ReactComponent };